import { render, staticRenderFns } from "./CFormList.vue?vue&type=template&id=c651b022&scoped=true&"
import script from "./CFormList.vue?vue&type=script&lang=js&"
export * from "./CFormList.vue?vue&type=script&lang=js&"
import style0 from "./CFormList.vue?vue&type=style&index=0&id=c651b022&scoped=true&lang=css&"
import style1 from "./CFormList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c651b022",
  null
  
)

export default component.exports